import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack,
} from '@mui/material';
import { Form, useTranslate, required } from 'react-admin';
import { GrayDateInputWithUpperLabel } from './inputs/GrayDateInputWithUpperLabel';

export type PlanRenewalFormValues = {
  plannedRenewalDate: string;
};
export const PlanRenewalModal = (props: {
  open: boolean;
  onClose: () => void;
  onBack?: () => void;
  onSubmit: (values: PlanRenewalFormValues) => Promise<void>;
  dateFieldSource?: string;
  dateFieldLabel: string;
  title: string;
}) => {

  const translate = useTranslate();
  const source = props.dateFieldSource ?? 'plannedRenewalDate';
  const handleSubmit = async (values: Record<string, unknown>) => {

    await props.onSubmit({
      plannedRenewalDate: values[source] as string,
    });

  };
  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{translate(props.title)}</DialogTitle>
      <DialogContent>
        <Form id="plan-renewal-form" onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ mt: 3 }}>
            <GrayDateInputWithUpperLabel
              source={source}
              label={props.dateFieldLabel}
              validate={required()}
            />
          </Stack>
        </Form>
      </DialogContent>
      <DialogActions>
        {props.onBack && (
          <Button onClick={props.onBack}>{translate('ra.action.back')}</Button>
        )}
        <Button onClick={props.onClose}>{translate('ra.action.cancel')}</Button>
        <Button type="submit" form="plan-renewal-form" variant="contained">
          {translate('ra.action.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );

};
